<template>
  <b-modal ref="modal-stethoscope" v-model="showModal" @close="close" size="lg">
    <div class="row">
      <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
        <img class="center-block subheader-img" src="~img/icons/morillas-svg-icons/primary/lamp-unplugged.svg"  v-if="!$store.state.video.useLamp"/>
        <img class="center-block subheader-img" src="~img/icons/morillas-svg-icons/primary/lamp-plugged.svg"  v-if="$store.state.video.useLamp" />
      </div>
      <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
        <div v-if="$store.state.video.useLamp">
          <span v-html="$t('lamp1')"></span>
          <img src="/static-appopensalud/img/icons/refresh-icon-blue-fill.svg" v-if="!$uiHelpers.isMobile" class="mt-4 rounded-btn" :title="$t('refresh-label')" style="display: block; margin: auto; background-color: rgb(78, 140, 255)"/>
        </div>
        <div v-if="!$store.state.video.useLamp">
          <span v-html="$t('lamp2')"></span>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="float-right ml-2" @click="switchLamp">
          {{$t('continue')}}
        </b-button>
        <base-button red class="float-right"  @click="close">
          {{$t('cancel')}}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { BModal, BButton, BIconArrowClockwise } from 'bootstrap-vue'

  export default {
    components: {
      BModal,
      BButton,
      BIconArrowClockwise
    },
    data () {
      return {
        showModal: false
      }
    },
    methods: {
      switchLamp () {
        this.$store.state.video.opentok.publisher.cycleVideo().then((device) => {
          this.$store.commit('video/setSelectedVideoSource', this.$store.state.video.videoDevices.filter(d => d.deviceId === device.deviceId)[0])
          this.$store.commit('video/useLamp', true)
          this.showModal = false
        })
      },
      close () {
        this.showModal = false
        this.$store.commit('video/toggleLamp')
      }
    }
  }
</script>

<style scoped>
  .center-block {
    display: block;
    margin-left: auto;
    margin-right: auto
  }

  .subheader-img {
    width: 150px; 
    margin: 0px auto 35px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/video-launcher/LampModal.vue